module.exports = __webpack_public_path__ + "static/img/十圖企業.e885ad8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/合作夥伴/十圖企業.jpg?20181011
// module id = abKc
// module chunks = 1